import { Brand } from "../Model/Brand";
import { BrandRepository } from "../Repository/BrandRepository";



export interface UpdateColorUseCase {
    invoke: (data: Brand) => Promise<boolean>;
  }
  
  export class UpdateBrand implements UpdateColorUseCase {
    private brandRepo: BrandRepository;
    constructor(_ColorRepo: BrandRepository) {
      this.brandRepo = _ColorRepo;
    }
  
    async invoke(data: Brand){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.brandRepo.updateColor(data);
        return update;
    }
  }